<template>
  <div class="wrapper">
    <div class="fixedCotanier">
      <div class="search-t">
        <div class="search-c">
          <img class="search" src="../../assets/images/search/search.svg" alt @click="search" />
          <input type="search" placeholder="请输入订单号/姓名/商品" v-model="searchinp" @keyup.13="search" />
          <img class="close" src="../../assets/images/search/close.svg" alt @click="returnHistory" />
        </div>
        <div class="return" @click="search">搜索</div>
      </div>
    </div>
    <van-tabs
      v-model="active"
      :swipe-threshold="5"
      color="#f44"
      sticky
      animated
      swipeable
      :line-width="30"
    >
      <van-tab
        :title="`${tab.title}${tab.totalRows&&active==i?'('+tab.totalRows+')':''}`"
        :id="'mid'+i"
        v-for="(tab,i) in menu"
        :key="i"
      >
        <div class="mid">
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <van-list
              v-model="loading"
              :finished="finished"
              :finished-text="list.length?'没有更多了':''"
              @load="loadMore"
              :immediate-check="true"
              :offset="20"
            >
              <div class="no" v-if="list.length == 0&&!loading">
                <img src="./../../assets/images/kb.png" alt />
                <div>暂无相关信息</div>
              </div>
              <van-row
                class="box"
                v-for="(item,index) in list"
                :key="index"
                @click.native="urlType(item)"
              >
                <div class="title">
                  <div class="left">
                    <span class="one">共{{item.order.length}}件商品</span>
                    <div class="two" v-if="item.is_group == 1">
                      <span>拼团</span>
                    </div>
                  </div>
                  <span v-if="item.show_nbr">退款编号：{{item.show_nbr}}</span>
                  <span v-else style="color:#E02020">{{item.state==6?'待发货':item.state==7?'待收货':"已收货"}}</span>
                </div>
                <div class="goodlistbox">
                  <van-row
                    class="goodlist"
                    type="flex"
                    v-for="(itemm,index1) in item.order"
                    :key="index1"
                  >
                    <img :src="itemm.commodity_first_pic + `${imgCrop}resize,w_300`" alt />
                    <van-row class="goodinfo">
                      <van-row class="name more-h">{{itemm.commodity_name}}</van-row>
                      <van-row type="flex" justify="space-between">
                        <van-col class="type more-h">{{itemm.property}}</van-col>
                      </van-row>
                      <van-col class="num">数量：{{itemm.refund_quantity}}</van-col>
                    </van-row>
                  </van-row>
                </div>
                <van-row class="btn" type="flex" justify="space-between" align="center">
                  <div class="leftbox">
                    <!-- v-if="active!=0" -->
                    <div class="imgbox" >
                      <img
                        v-if="item.refund_type=='1'||item.refund_type=='2'||item.refund_type=='4'||item.refund_type=='8'"
                        src="./../../assets/images/handling.png"
                        alt
                      />
                      <img
                        v-else-if="item.refund_type=='3'||item.refund_type=='9'"
                        src="./../../assets/images/backCommodity.png"
                        alt
                      />
                      <img
                        v-else-if="item.refund_type=='5'"
                        src="./../../assets/images/changeCommodity.png"
                        alt
                      />
                      <img
                        v-else-if="item.refund_type=='6'"
                        src="./../../assets/images/payPrice.png"
                        alt
                      />
                      <img
                        v-else-if="item.refund_type=='7'"
                        src="./../../assets/images/buPrice.png"
                        alt
                      />
                    </div>
                    <!-- v-if="active!=0" -->
                    <div class="textbox" >
                      {{item.refund_type=='1'||item.refund_type=='2'||item.refund_type=='4'||item.refund_type=='8'?'退款':(item.refund_type=='3'||item.refund_type=='9')?'退货退款':item.refund_type=='5'?'换货':item.refund_type=='6'?'补偿':'补发'}}
                      <span
                        v-if="item.state==1"
                        class="span"
                      >审核中</span>
                      <span
                        v-if="item.state==2&&(!item.pickup_state||item.pickup_state&&(item.pickup_state==4||item.pickup_state==5))&&(item.refund_type==3||item.refund_type==9)"
                        class="span"
                      >同意退货</span>
                      <span
                        v-if="item.state==2&&item.pickup_state==1&&(item.refund_type==3||item.refund_type==5||item.refund_type==9)"
                        class="span"
                      >等待接单</span>
                      <span
                        v-if="item.state==2&&item.pickup_state==2&&(item.refund_type==3||item.refund_type==5||item.refund_type==9)"
                        class="span"
                      >等待揽件</span>
                      <span
                        v-if="item.state==2&&item.pickup_state==3&&(item.refund_type==3||item.refund_type==9)"
                        class="span"
                      >退货退款中</span>
                      <span
                        v-if="item.state==2&&!item.pickup_state&&item.refund_type==7"
                        class="span"
                      >等待补货发货</span>
                      <span
                        v-if="item.state==2&&!item.pickup_state&&item.refund_type==5"
                        class="span"
                      >等待退货</span>
                      <span
                        v-if="item.state==2&&item.pickup_state==3&&item.refund_type==5"
                        class="span"
                      >换货中</span>
                      <span
                        v-if="item.state==3&&(item.refund_type=='1'||item.refund_type=='2'||item.refund_type=='4'||item.refund_type=='8')"
                        class="span"
                      >成功</span>
                      <span
                        v-if="item.state==4&&(item.refund_type=='1'||item.refund_type=='2'||item.refund_type=='4'||item.refund_type=='8')"
                        class="span"
                      >失败</span>
                      <span v-if="item.state==3&&(item.refund_type==3||item.refund_type==9)" class="span">成功</span>
                      <span v-if="item.state==4&&(item.refund_type==3||item.refund_type==9)" class="span">失败</span>
                      <span v-if="item.state==3&&item.refund_type==5" class="span">成功</span>
                      <span v-if="item.state==4&&item.refund_type==5" class="span">失败</span>
                      <span v-if="item.state==3&&item.refund_type==6" class="span">成功</span>
                      <span v-if="item.state==4&&item.refund_type==6" class="span">失败</span>
                      <span v-if="item.state==3&&item.refund_type==7" class="span">成功</span>
                      <span v-if="item.state==4&&item.refund_type==7" class="span">失败</span>
                    </div>
                  </div>
                  <!--<div>仅退款 退款失败 <span>退款中</span>退款成功</div>-->
                  <div @click.stop>
                    <van-button
                      round
                      type="default"
                      size="small"
                      class="default"
                      @click.native.stop="urlType(item)"
                    >{{active==0&&parseFloat(item.unpay_postage_amount||'0')>0?'待支付':'查看详情'}}</van-button>
                  </div>
                </van-row>
              </van-row>
            </van-list>
          </van-pull-refresh>
        </div>
      </van-tab>
    </van-tabs>
    <!-- 请填写退货物流信息 -->
    <van-popup v-model="show" position="bottom" :close-on-click-overlay="false">
      <van-row class="popup">
        <van-row class="content" type="flex" justify="center" align="center">请填写退货物流信息</van-row>
        <van-row class="inputbox">
          <div class="boxinput">
            <input type="text" placeholder="请输入物流公司名称" v-model="refundexpressname" />
          </div>
          <div class="boxinput">
            <input type="number" placeholder="请输入物流单号" v-model="refundexpressid" />
          </div>
        </van-row>
        <van-row class="bottombox">
          <van-col class="cancel" @click.native="show=false">取消</van-col>
          <van-col class="confirm" @click.native.stop="refund">确定</van-col>
        </van-row>
      </van-row>
    </van-popup>
  </div>
</template>

<script>
import weChatShareApi from "../../assets/js/weChatShare";
import { mapGetters } from "vuex";
export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      menu: [
        // { title: "申请售后" },
        { title: "处理中" },
        { title: "售后评价" },
        { title: "售后记录" }
      ],
      show: false,
      showNbr: "",
      refundexpressid: "",
      refundexpressname: "",
      isLoading: false,
      loading: false,
      finished: false,
      list: "",
      pageIndex: 0,
      numPerPage: 10,
      searchinp: "",
      oldSearch: "",
      active: 0,
      scroll: 0,
      keepAlive: true, //
    };
  },
  computed: {
    ...mapGetters(["payment"])
  },
  methods: {
    urlType(item) {
      this.$router.push({
        path: "/replacementdetail",
        query: { nbr: item.nbr, supNbr: this.userInfo.nbr }
      });
      // if (this.active == 0) {
      //   this.$router.push({
      //     path: "/orderdetail",
      //     query: { nbr: item.order_nbr, supNbr: this.userInfo.nbr }
      //   });
      // } else { // 物流
      //   this.$router.push({
      //     path: "/replacementdetail",
      //     query: { nbr: item.nbr, supNbr: this.userInfo.nbr }
      //   });
      // }
    },
    search() {
      this.loading = true; //手动控制上啦正在加载，防止多次请求
      this.finished = true;
      this.list = [];
      this.pageIndex = 0;
      if(document.getElementById("mid" + this.active)){
        document.getElementById("mid" + this.active).scrollTop = 0;
      }
      this.oldSearch = this.searchinp;
      this.getData();
    },
    returnHistory() {
      this.searchinp = "";
      this.oldSearch = "";
      this.search();
    },
    showup(nbr) {
      this.showNbr = nbr;
      this.show = true;
    },
    onRefresh() {
      this.pageIndex = 0;
      this.isLoading = true;
      this.finished = false;
      this.list = [];
      this.getData();
    },
    loadMore() {
      if (!this.finished) {
        this.pageIndex++;
        this.getData();
      }
    },
    refund() {
      this.loading = true;
      let refundNbr = this.showNbr;
      // 加载框子
      const toast = this.$toast({
        type: "loading",
        message: "正在提交...",
        duration: 0,
        mask: true
      });
      this.$post("/api/customer/refundOrder/inputRefundExpressNew", {
        refundNbr: refundNbr,
        refundExpressId: this.refundexpressid,
        refundExpressName: this.refundexpressname,
      }).then((data) => {
        if (data.code == "200") {
          let resp = data.object.resp;
          if (resp.resp_code == "0" && resp.resp_result == "0") {
            this.show = false;
            this.$toast({
              message: "单号填写成功",
              duration: 1000
            });
          } else {
            this.$toast({
              message: resp.resp_msg,
              duration: 2000
            });
          }
        } else {
          this.$toast({
            message: data.message,
            duration: 2000
          });
        }
      }).catch((err) => {
        toast.clear();
        this.$toast({
          message: err.message,
          duration: 2000,
        });
      });
      // this.$commonPost({
      //   jydm: "flow_40006",
      //   flow_40006: {
      //     nbr: refundNbr,
      //     refund_express_id: this.refundexpressid,
      //     refund_express_name: this.refundexpressname
      //   }
      // })
      //   .then(response => {
      //     this.show = false;
      //     this.$toast({
      //       message: "单号填写成功",
      //       duration: 1000
      //     });
      //   })
      //   .catch(err => {
      //     this.$toast({
      //       message: err.message,
      //       duration: 2000
      //     });
      //   });
    },
    getData() {
      this.loading = true;
      this.oldData()
      // this.active == 0 ? this.newData() : this.oldData();
    },
    newData() {
      this.$commonPost({
        jydm: "flow_40029",
        flow_40029: {
          user_nbr: this.userInfo.nbr,
          search: this.oldSearch,
          page_index: this.pageIndex * this.numPerPage,
          num_per_page: this.numPerPage
        }
      })
        .then(response => {
          let arr = [];
          if (response.list) {
            if (response.list.length > 0) {
              arr = response.list;
            } else {
              arr.push(response.list);
            }
          }
          arr.map(function(item) {
            let newArr = [
              {
                commodity_name: item.commodity_name,
                commodity_first_pic: item.commodity_logo,
                property: item.commodity_property,
                refund_quantity: item.quantity
              }
            ];
            item.order = newArr;
          });
          this.list = this.list.concat(arr);
          if (arr.length < this.numPerPage) {
            this.finished = true;
          } else {
            this.finished = false;
          }
          this.loading = false;
          this.isLoading = false;
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    oldData() {
      this.$commonPost({
        jydm: "flow_40003",
        flow_40003: {
          user_nbr: this.userInfo.nbr,
          search: this.oldSearch,
          page_index: this.pageIndex * this.numPerPage,
          num_per_page: this.numPerPage,
          state: parseInt(this.active)+1
        }
      })
        .then(response => {
          let arr = [];
          if (response.refund_list) {
            if (response.refund_list.length > 0) {
              arr = response.refund_list;
            } else {
              arr.push(response.refund_list);
            }
          }
          arr.map(function(item) {
            let newArr = [];
            if (item.order.length > 0) {
              newArr = item.order;
            } else {
              newArr.push(item.order);
            }
            item.order = newArr;
          });
          this.list = this.list.concat(arr);
          this.menu[this.active].totalRows = response.total_rows;
          this.loading = false;
          this.isLoading = false;
          if (arr.length < this.numPerPage) {
            this.finished = true;
          } else {
            this.finished = false;
          }
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    initPage() {
      let option = {
        title: "有米@" + this.userInfo.name + "的店铺",
        desc: "欢迎光临我的店铺",
        link: location.origin + "/?supNbr=" + this.userInfo.nbr,
        images: this.userInfo.imgUrl
      };
      this.weChatShare(option);
      if(document.getElementById("mid" + this.active)){
        document.getElementById("mid" + this.active).scrollTop = this.scroll;
      }
      if (this.keepAlive) {
        (this.isLoading = false),
          (this.loading = false),
          (this.finished = false),
          (this.list = []),
          (this.pageIndex = 0),
          (this.totalRows = 0),
          (this.searchinp = ""),
          (this.oldSearch = ""),
          this.getData();
      }
    }
  },
  created() {},
  watch: {
    $route(to, from) {
      if (from.path == "/information" || from.path == "/placeorder" || from.path == "/orderdetail") {
        this.keepAlive = true;
      } else {
        this.keepAlive = false;
      }
    },
    active(val, old) {
      this.search();
    },
    payment(val, old) {
      if (val==1) {
        this.search();
      }
    }
  },
  activated() {
    document.title = "售后";
    this.initPage();
  },
   beforeRouteLeave(to, from, next) {
    //记录离开页面元素的高度
    if(document.getElementById("mid" + this.active)){
      this.scroll = document.getElementById("mid" + this.active).scrollTop;
    }
    this.$store.commit("SENDpayment", '');
    next();
  },
  mounted() {}
};
</script>
<style scoped lang='stylus'>
.mid >>> .van-pull-refresh__track {
  min-height: calc(100vh - 2.04rem);
}

.mid >>> .no {
  margin: 0 auto 0;
  padding-top: 2rem;
  text-align: center;

  img {
    width: 3.64rem;
    height: 2.1rem;
    margin-bottom: 0.6rem;
  }
}

.wrapper >>> .van-tab__pane {
  height: calc(100vh - 1.8rem);
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}
</style>
<style scoped lang='less'>
.fixedCotanier {
  background: #fff;
  width: 100%;
  box-shadow: 0 2px 18px 0 rgba(0, 0, 0, 0.02);
  padding: 0.14rem 0;
}
.search-t {
  margin: 0 auto;
  width: 7.02rem;
  height: 0.6rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.search-t .search-c {
  flex: 1;
  background-color: #f9f9f9;
  border-radius: 0.3rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.search-t .return {
  color: #333;
  font-size: 0.28rem;
  margin-left: 0.24rem;
}
.search-t .return img {
  width: 0.4rem;
  height: 0.4rem;
}
.search-t .search {
  margin-left: 0.18rem;
  vertical-align: middle;
  width: 0.36rem;
  height: 0.36rem;
}
.search-t .close {
  margin-right: 0.18rem;
  vertical-align: middle;
  width: 0.36rem;
  height: 0.36rem;
}
.search-t input {
  flex: 1;
  display: inline-block;
  margin-left: 0.18rem;
  background: none;
  border: none;
  //   color: #f7f7f7;
  line-height: 0.6rem;
  font-size: 0.28rem;
}
input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: none;
}
.search-t input::-webkit-input-placeholder {
  color: #999;
}
.search-t input::-ms-input-placeholder {
  //由于我的IE刚好是IE9，支持不了placeholder，所以也测试不了(⊙﹏⊙)，有IE10以上的娃可以帮我试试
  color: #999;
}
.wrapper {
  width: 100%;
  background: #f5f5f5;
  height: 100vh;
}

.mid {
  box-sizing: border-box;
  padding-top: 0.2rem;
  max-height: calc(100vh - 1.8rem);
  .box {
    width: 7.02rem;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 0.16rem;
    margin: 0 auto;
    margin-bottom: 0.2rem;
    padding: 0 0.2rem;
    .title {
      height: 0.68rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .one {
          font-size: 0.24rem;
          color: #666666;
        }
        .two {
          width: 1.26rem;
          height: 0.68rem;
          background-image: linear-gradient(-90deg, #fd3741 0%, #fe7202 100%);
          border-radius: 0.04rem;
          transform: scale(0.5);
          transform-origin: left;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: 0.2rem;
          span {
            font-size: 0.4rem;
            color: #ffffff;
          }
        }
      }
      span {
        font-size: 0.24rem;
        color: #333333;
        font-weight: 400;
      }
    }
    .goodlistbox {
      margin-top: 0.17rem;
      border-bottom: 1px solid #eeeeee;
      .goodlist {
        margin-bottom: 0.22rem;
        img {
          width: 1.8rem;
          height: 1.8rem;
          border-radius: 0.04rem;
          object-fit: cover;
        }
        .goodinfo {
          flex: 1;
          margin-left: 0.24rem;
          font-size: 0.24rem;
          color: #999999;
          line-height: 0.34rem;
          display: flex;
          flex-direction: column;
          position: relative;
          .name {
            font-weight: bold;
            color: #333333;
            margin-bottom: 0.08rem;
          }
          .num {
            margin-top: 0.12rem;
          }
          .type {
            word-wrap: break-word;
            width: 3.8rem;
          }
        }
        .goodinfo:after {
          display: none;
        }
      }
    }
    .btn {
      text-align: right;
      margin: 0.24rem 0;
      .leftbox {
        display: flex;
        align-items: center;
        .imgbox {
          img {
            width: 0.38rem;
            height: 0.38rem;
          }
        }
        .textbox {
          font-size: 0.24rem;
          margin-left: 0.16rem;
        }
      }
      .span {
        font-weight: 400;
        color: #e52b25;
      }
      .defaultl {
        width: 1.48rem;
        color: #333333;
        height: 0.5rem;
        line-height: 0.5rem;
        font-size: 0.26rem;
        background: #ffffff;
        border: 1px solid #333333;
        border-radius: 0.25rem;
      }
      .default {
        width: 1.48rem;
        color: #e52b25;
        height: 0.5rem;
        line-height: 0.5rem;
        font-size: 0.26rem;
        background: #ffffff;
        border: 1px solid #e52b25;
        border-radius: 0.25rem;
      }
      .purple {
        width: 1.48rem;
        background: #5045d8;
        height: 0.5rem;
        color: #ffffff;
        font-size: 0.28rem;
      }
    }
  }
}
.van-popup {
  border-top-left-radius: 0.18rem;
  border-top-right-radius: 0.18rem;
  .popup {
    height: 5.6rem;
    .content {
      height: 0.88rem;
      font-weight: bold;
      font-size: 0.34rem;
      color: #333333;
      margin-top: 0.18rem;
    }
    .inputbox {
      margin-top: 0.7rem;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .boxinput {
        width: 6.9rem;
        height: 0.88rem;
        background: #f5f5f5;
        border-radius: 0.44rem;
        display: flex;
        align-items: center;
        input {
          height: 0.4rem;
          border: 0;
          margin-left: 0.44rem;
          background: #f5f5f5;
        }
      }
      .boxinput:first-of-type {
        margin-bottom: 0.24rem;
      }
      .boxinput:last-child {
        margin-bottom: 1.06rem;
      }
    }
    .bottombox {
      height: 0.98rem;
      .cancel {
        height: 0.98rem;
        line-height: 0.98rem;
        text-align: center;
        width: 50%;
        font-weight: bold;
        background: #333333;
        color: #333333;
        font-size: 0.3rem;
        color: #ffffff;
      }
      .confirm {
        height: 0.98rem;
        line-height: 0.98rem;
        text-align: center;
        background: #e52b25;
        width: 50%;
        font-size: 0.3rem;
        font-weight: bold;
        color: #ffffff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/information/replacementlist.vue